import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import { useTableHook, TableConfiguration } from '@hooks/useTableHook';

import { IReportSummaryAPIResponse } from '@models';

import { HOCTable } from '@components';
import BasicCell from '@components/TableCells/BasicCell/BasicCell';

import {
  DownloadResultsTableReturnState,
  getInactiveReportStatuses,
} from '../../helpers/results-package-helper';

import ReportIDCell from './ReportIDCell';
import './DownloadResultsTable.scss';

// Download Table config
const tableConfiguration: TableConfiguration = {
  api: null,
  localData: null,
  sortedBy: null,
  columns: ['SAMPLE NAME', 'PATIENT ID', 'TYPE', 'REPORT ID'],
};

interface DownloadResultsTableProps {
  list: IReportSummaryAPIResponse[];
}

const DownloadResultsTable: React.FC<DownloadResultsTableProps> = React.memo(
  ({ list }) => {
    const [rows, setRows] = useState<JSX.Element[]>([]);
    const { data, columns }: DownloadResultsTableReturnState = useTableHook({
      ...tableConfiguration,
      localData: list,
    });

    // generate the rows when the data changes
    useEffect(() => {
      if (data.length > 0) {
        const rows = _.map(
          data,
          (
            { order, orderTest, hasActiveReport, clinicalReport, specimen },
            idx
          ) => {
            const inactiveReport = getInactiveReportStatuses(
              clinicalReport.status,
              hasActiveReport
            );
            return (
              <tr
                key={`report-${order.id + '-' + idx}`}
                className={`${
                  inactiveReport.isObsoleteReport ||
                  inactiveReport.isOutdatedReport
                    ? 'inactive-report'
                    : 'active-report'
                }`}
              >
                <BasicCell value={orderTest.sampleName}></BasicCell>
                <BasicCell value={clinicalReport.externalSubjectId}></BasicCell>
                <BasicCell value={orderTest.testType}></BasicCell>
                <ReportIDCell
                  hasActiveReport={hasActiveReport}
                  reportStatus={clinicalReport.status}
                  value={clinicalReport.name}
                  urlParams={{
                    patientId: specimen.externalSubjectId,
                    sampleName: orderTest.sampleName,
                    specimenNumber: specimen.specimenNumber,
                  }}
                ></ReportIDCell>
              </tr>
            );
          }
        );
        setRows(rows);
      }
    }, [data]);

    return <HOCTable columns={columns} rows={rows} />;
  }
);

export default DownloadResultsTable;
